module.exports = __webpack_public_path__ + "img/Plant a plant.88572a3c.png";